import {Entity} from '@s-ui/domain'

export class CommentIdEntity extends Entity {
  /**
   * @constructor
   * @param {Object} data
   * @param {String} data.id
   */
}
